import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-ga-verify',
  templateUrl: './ga-verify.component.html',
  styleUrl: './ga-verify.component.scss',
})
export class GaVerifyComponent {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  otpArray: string[] = ['', '', '', '', '', ''];
  userId!: number;

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly toast: ToastService,
  ) {
    this.userId = Number(localStorage.getItem('otp_user_id'));
  }

  ngAfterViewInit() {
    this.focusInput(0);
  }

  focusInput(index: number) {
    if (this.otpInputs && this.otpInputs.toArray()[index]) {
      this.otpInputs.toArray()[index].nativeElement.focus();
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  onInput(index: number, event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Allow only numbers
    value = value.replace(/\D/g, '');

    // If more than 1 char (e.g. paste), take first char
    if (value.length > 1) {
      value = value[0];
    }

    this.otpArray[index] = value;
    input.value = value;

    if (value && index < 5) {
      // Defer focus to prevent issue where the same keystroke might be registered in the next input
      setTimeout(() => {
        this.focusInput(index + 1);
      }, 10);
    }

    this.checkVerify();
  }

  onKeyDown(index: number, event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace') {
      if (!input.value && index > 0) {
        event.preventDefault();
        this.focusInput(index - 1);
      } else if (input.value) {
        this.otpArray[index] = '';
        input.value = ''; // Ensure view is updated immediately
      }
    } else if (event.key === 'ArrowLeft') {
      if (index > 0) {
        event.preventDefault();
        this.focusInput(index - 1);
      }
    } else if (event.key === 'ArrowRight') {
      if (index < 5) {
        event.preventDefault();
        this.focusInput(index + 1);
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text') || '';
    const digits = paste.replace(/\D/g, '').slice(0, 6).split('');

    digits.forEach((digit, i) => {
      if (i < 6) {
        this.otpArray[i] = digit;
        if (this.otpInputs && this.otpInputs.toArray()[i]) {
          this.otpInputs.toArray()[i].nativeElement.value = digit;
        }
      }
    });

    const nextIndex = Math.min(digits.length, 5);
    this.focusInput(nextIndex < 6 ? (digits.length === 6 ? 5 : nextIndex) : 5);

    this.checkVerify();
  }

  checkVerify() {
    const otp = this.otpArray.join('');
    if (otp.length === 6) {
      this.verify(otp);
    }
  }

  verify(otp: string) {
    this.auth.verifyGaSetup({ otp: otp, userId: this.userId }).subscribe((resp: any) => {
      if (resp.status == 'success') {
        this.toast.success('Google Authenticator enabled successfully');
        this.router.navigate(['/']);
      } else {
        // Verify failed logic if needed (e.g. clear inputs)
      }
    }, (error) => {
      // Handle error
      this.toast.failure(error?.error?.message || 'Verification failed');
    });
  }

  goTo() {
    this.router.navigate(['/ga-setup'])
  }
}
